import type { BannerClickPayload } from '~/components/shared/BannerCarousel/banner.types'
import { useAnalytics } from '~/composables/analytics/useAnalytics'

export function useTrackCarouselBannerClick() {
  const { trackEvent } = useAnalytics()

  function trackCarouselBannerClick({ name, url }: BannerClickPayload) {
    trackEvent('banner_clicked', {
      banner_name: name,
      banner_url: url ?? '',
    })
  }

  return { trackCarouselBannerClick }
}
